<template>
  <svg
    v-if="domain === 'youth-support'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 42 47">
    <g filter="url(#a)">
      <path
        fill="#2A8D9A"
        fill-rule="evenodd"
        d="M6 6a3 3 0 0 1 3-3h24a3 3 0 0 1 3 3v24a3 3 0 0 1-3 3h-5.424a3 3 0 0 0-2.039.799L21 38l-4.537-4.201A3 3 0 0 0 14.424 33H9a3 3 0 0 1-3-3V6Z"
        clip-rule="evenodd" />
      <path
        stroke="#fff"
        d="M6.5 6A2.5 2.5 0 0 1 9 3.5h24A2.5 2.5 0 0 1 35.5 6v24a2.5 2.5 0 0 1-2.5 2.5h-5.424a3.5 3.5 0 0 0-2.378.932L21 37.319l-4.198-3.887a3.5 3.5 0 0 0-2.378-.932H9A2.5 2.5 0 0 1 6.5 30V6Z" />
    </g>
    <path fill="#3459A8" d="M21.03 12.05h.04-.04Z" />
    <path
      fill="#fff"
      d="M15 19.945c0 1.65.46 2.903 1.382 3.764.92.861 2.164 1.291 3.727 1.291h3.29c1.455 0 2.586-.396 3.392-1.19.806-.794 1.209-1.961 1.209-3.501V12h-7.309v7.945H15Z" />
    <defs>
      <filter
        id="a"
        width="42"
        height="47"
        x="0"
        y="0"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix values="0 0 0 0 0.611385 0 0 0 0 0.611385 0 0 0 0 0.611385 0 0 0 0.5 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1411_4225" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_1411_4225" result="shape" />
      </filter>
    </defs>
  </svg>

  <svg
    v-else-if="domain === 'community-work'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 42 47">
    <g filter="url(#a)">
      <path
        fill="red"
        fill-rule="evenodd"
        d="M6 6a3 3 0 0 1 3-3h24a3 3 0 0 1 3 3v24a3 3 0 0 1-3 3h-5.424a3 3 0 0 0-2.039.799L21 38l-4.537-4.201A3 3 0 0 0 14.424 33H9a3 3 0 0 1-3-3V6Z"
        clip-rule="evenodd" />
      <path
        stroke="#fff"
        d="M6.5 6A2.5 2.5 0 0 1 9 3.5h24A2.5 2.5 0 0 1 35.5 6v24a2.5 2.5 0 0 1-2.5 2.5h-5.424a3.5 3.5 0 0 0-2.378.932L21 37.319l-4.198-3.887a3.5 3.5 0 0 0-2.378-.932H9A2.5 2.5 0 0 1 6.5 30V6Z" />
    </g>
    <path
      fill="#fff"
      d="M23.63 25c1.408 0 2.488-.31 3.24-.927.754-.618 1.13-1.497 1.13-2.635 0-.747-.217-1.405-.652-1.974-.434-.57-1.043-.946-1.827-1.13a2.833 2.833 0 0 0 1.588-1.037c.398-.52.597-1.16.597-1.918 0-1.102-.38-1.94-1.138-2.516-.76-.575-1.8-.863-3.122-.863H15v13h8.63Z" />
    <defs>
      <filter
        id="a"
        width="42"
        height="47"
        x="0"
        y="0"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix values="0 0 0 0 0.611385 0 0 0 0 0.611385 0 0 0 0 0.611385 0 0 0 0.5 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1411_4215" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_1411_4215" result="shape" />
      </filter>
    </defs>
  </svg>

  <svg
    v-else-if="domain === 'child-care'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 42 47">
    <g filter="url(#a)">
      <path
        fill="#E89900"
        fill-rule="evenodd"
        d="M6 6a3 3 0 0 1 3-3h24a3 3 0 0 1 3 3v24a3 3 0 0 1-3 3h-5.424a3 3 0 0 0-2.039.799L21 38l-4.537-4.201A3 3 0 0 0 14.424 33H9a3 3 0 0 1-3-3V6Z"
        clip-rule="evenodd" />
      <path
        stroke="#fff"
        d="M6.5 6A2.5 2.5 0 0 1 9 3.5h24A2.5 2.5 0 0 1 35.5 6v24a2.5 2.5 0 0 1-2.5 2.5h-5.424a3.5 3.5 0 0 0-2.378.932L21 37.319l-4.198-3.887a3.5 3.5 0 0 0-2.378-.932H9A2.5 2.5 0 0 1 6.5 30V6Z" />
    </g>
    <path fill="#fff" d="m28 25-4.81-6.684L28 12H15v13h13Z" />
    <defs>
      <filter
        id="a"
        width="42"
        height="47"
        x="0"
        y="0"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix values="0 0 0 0 0.611385 0 0 0 0 0.611385 0 0 0 0 0.611385 0 0 0 0.5 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1411_4214" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_1411_4214" result="shape" />
      </filter>
    </defs>
  </svg>

  <svg
    v-else-if="domain === 'maternity-care'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 42 47">
    <g filter="url(#a)">
      <path
        fill="#622E60"
        fill-rule="evenodd"
        d="M6 6a3 3 0 0 1 3-3h24a3 3 0 0 1 3 3v24a3 3 0 0 1-3 3h-5.424a3 3 0 0 0-2.039.799L21 38l-4.537-4.201A3 3 0 0 0 14.424 33H9a3 3 0 0 1-3-3V6Z"
        clip-rule="evenodd" />
      <path
        stroke="#fff"
        d="M6.5 6A2.5 2.5 0 0 1 9 3.5h24A2.5 2.5 0 0 1 35.5 6v24a2.5 2.5 0 0 1-2.5 2.5h-5.424a3.5 3.5 0 0 0-2.378.932L21 37.319l-4.198-3.887a3.5 3.5 0 0 0-2.378-.932H9A2.5 2.5 0 0 1 6.5 30V6Z" />
    </g>
    <path fill="#fff" d="M15 11v13h13l-3.795-4.919 3.707-4.989h-7.01V11H15Z" />
    <defs>
      <filter
        id="a"
        width="42"
        height="47"
        x="0"
        y="0"
        color-interpolation-filters="sRGB"
        filterUnits="userSpaceOnUse">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="3" />
        <feColorMatrix values="0 0 0 0 0.611385 0 0 0 0 0.611385 0 0 0 0 0.611385 0 0 0 0.5 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1411_4221" />
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_1411_4221" result="shape" />
      </filter>
    </defs>
  </svg>

  <svg
    v-else-if="domain === 'head-office'"
    viewBox="0 0 179 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1213_702)">
      <g filter="url(#filter0_d_1213_702)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M25.5319 25.5318C25.5319 22.1461 26.8769 18.899 29.271 16.5049C31.6651 14.1109 34.9121 12.7659 38.2979 12.7659H140.426C143.811 12.7659 147.058 14.1109 149.452 16.5049C151.847 18.899 153.191 22.1461 153.191 25.5318V127.659C153.191 131.045 151.847 134.292 149.452 136.686C147.058 139.08 143.811 140.425 140.426 140.425H117.345C114.127 140.425 111.029 141.639 108.668 143.825L89.3617 161.702L70.0553 143.825C67.6949 141.639 64.596 140.425 61.3787 140.425H38.2979C34.9121 140.425 31.6651 139.08 29.271 136.686C26.8769 134.292 25.5319 131.045 25.5319 127.659V25.5318Z"
          fill="#1F122E" />
        <path
          d="M27.6595 25.5319C27.6595 22.7104 28.7804 20.0045 30.7754 18.0094C32.7705 16.0144 35.4764 14.8936 38.2978 14.8936H140.426C143.247 14.8936 145.953 16.0144 147.948 18.0094C149.943 20.0045 151.064 22.7104 151.064 25.5319V127.66C151.064 130.481 149.943 133.187 147.948 135.182C145.953 137.177 143.247 138.298 140.426 138.298H117.345C113.592 138.298 109.979 139.714 107.226 142.264L89.3617 158.804L71.4978 142.264C68.7448 139.714 65.1309 138.298 61.3787 138.298H38.2978C35.4764 138.298 32.7705 137.177 30.7754 135.182C28.7804 133.187 27.6595 130.481 27.6595 127.66V25.5319Z"
          stroke="white"
          stroke-width="4.25532" />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M103.927 51.4789H95.3309V57.4827C94.376 55.5008 92.9041 53.9392 90.9084 52.7879C88.9133 51.6367 86.5325 51.0637 83.7552 51.0637C80.7649 51.0637 78.091 51.7471 75.7277 53.1141C73.3641 54.4809 71.5009 56.4416 70.1322 58.9969C68.7697 61.557 68.0851 64.58 68.0851 68.0658C68.0851 71.5145 68.7697 74.5268 70.1322 77.1031C71.5009 79.6791 73.3641 81.6506 75.7277 83.0176C78.091 84.3844 80.7649 85.0678 83.7552 85.0678C86.5325 85.0678 88.9133 84.4946 90.9084 83.3433C92.9041 82.1918 94.376 80.6307 95.3309 78.6486V85.6617C95.3309 88.3169 94.6291 90.246 93.2202 91.4552C91.8116 92.6645 89.954 93.269 87.6596 93.269C85.6645 93.269 84.0485 92.8906 82.812 92.1386C81.5814 91.3869 80.7879 90.3355 80.4431 88.9897H69.4538C70.1035 93.0325 72.0643 96.2342 75.3365 98.5894C78.6086 100.95 82.9788 102.128 88.4418 102.128C92.4267 102.128 95.7618 101.397 98.4531 99.9299C101.138 98.4631 103.134 96.4918 104.433 94.0154C105.733 91.5342 106.383 88.7529 106.383 85.6617V53.7239C106.383 52.4832 105.285 51.4789 103.927 51.4789ZM93.088 73.9485C91.593 75.4154 89.6721 76.1512 87.3319 76.1512C84.9512 76.1512 83.0306 75.4366 81.5814 74.0116C80.1267 72.5818 79.4021 70.5994 79.4021 68.0658C79.4021 65.5319 80.1267 63.5445 81.5814 62.1197C83.0306 60.6952 84.9512 59.98 87.3319 59.98C89.6721 59.98 91.593 60.7053 93.088 62.1512C94.5833 63.5969 95.3309 65.5687 95.3309 68.0658C95.3309 70.5208 94.5833 72.4817 93.088 73.9485Z"
        fill="white" />
    </g>
    <defs>
      <filter
        id="filter0_d_1213_702"
        x="-5.34058e-05"
        y="-8.7738e-05"
        width="178.723"
        height="200.002"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha" />
        <feOffset dy="12.766" />
        <feGaussianBlur stdDeviation="12.766" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.611385 0 0 0 0 0.611385 0 0 0 0 0.611385 0 0 0 0.5 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1213_702" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1213_702"
          result="shape" />
      </filter>
      <clipPath id="clip0_1213_702">
        <rect width="178.723" height="200" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup lang="ts">
import type { Domain } from '@gro-up/types'

defineProps<{
  domain: Domain
}>()
</script>
